var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12.2833 15 12.521 14.904 12.713 14.712C12.905 14.52 13.0007 14.2827 13 14C12.9993 13.7173 12.9033 13.48 12.712 13.288C12.5207 13.096 12.2833 13 12 13C11.7167 13 11.4793 13.096 11.288 13.288C11.0967 13.48 11.0007 13.7173 11 14C10.9993 14.2827 11.0953 14.5203 11.288 14.713C11.4807 14.9057 11.718 15.0013 12 15ZM12 11C12.2833 11 12.521 10.904 12.713 10.712C12.905 10.52 13.0007 10.2827 13 10V6C13 5.71667 12.904 5.47933 12.712 5.288C12.52 5.09667 12.2827 5.00067 12 5C11.7173 4.99933 11.48 5.09533 11.288 5.288C11.096 5.48067 11 5.718 11 6V10C11 10.2833 11.096 10.521 11.288 10.713C11.48 10.905 11.7173 11.0007 12 11ZM6 18L3.7 20.3C3.38334 20.6167 3.02067 20.6877 2.612 20.513C2.20333 20.3383 1.99933 20.0257 2 19.575V4C2 3.45 2.196 2.97933 2.588 2.588C2.98 2.19667 3.45067 2.00067 4 2H20C20.55 2 21.021 2.196 21.413 2.588C21.805 2.98 22.0007 3.45067 22 4V16C22 16.55 21.8043 17.021 21.413 17.413C21.0217 17.805 20.5507 18.0007 20 18H6ZM5.15 16H20V4H4V17.125L5.15 16Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.d950de69000a32935054ec1c41f84a98.svg";
export { ForwardRef as ReactComponent };